import {
    Stack,
    Typography,
    Button,
    InputAdornment,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions
} from "@mui/material";
import Box from "@mui/material/Box";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import CustomTable from "../../components/customTable";
import CustomizedSnackbars from "../../components/snackbar";
import {
    useGetDelinkRequestsQuery,
    useUpdateDelinkRequestStatusMutation
} from "../../redux/api";
import { format } from 'date-fns';
import searchIcon from "../../assets/images/icons/searchIcon.svg";
import { CustomSearchInput } from "../../utils/constant";
import useDebounce from "../../hooks/use.debounce";

const DelinkRequests = () => {
    // const navigate = useNavigate(); // Unused
    const [page, setPage] = useState(0);
    const [limit, setLimit] = useState(10);
    const [search, setSearch] = useState("");
    const debouncedSearch = useDebounce(search, 500);

    const { data, refetch } = useGetDelinkRequestsQuery({
        limit,
        offset: page * limit,
        search: debouncedSearch
    });

    const [updateStatus, { isLoading: isUpdating }] = useUpdateDelinkRequestStatusMutation();
    const [snackbar, setSnackbar] = React.useState({
        message: "",
        severity: "success",
        open: false,
    });

    const [confirmationState, setConfirmationState] = useState({
        open: false,
        userId: null,
        status: null,
        instant: false
    });

    const openConfirmation = (userId, status, instant = false) => {
        setConfirmationState({
            open: true,
            userId,
            status,
            instant
        });
    };

    const closeConfirmation = () => {
        setConfirmationState({
            open: false,
            userId: null,
            status: null,
            instant: false
        });
    };

    const handleConfirmAction = () => {
        if (confirmationState.userId && confirmationState.status) {
            handleUpdateStatus(confirmationState.userId, confirmationState.status, confirmationState.instant);
        }
        closeConfirmation();
    };


    const handleUpdateStatus = async (userId, status, instant = false) => {
        try {
            const res = await updateStatus({ userId, status, instant }).unwrap();
            if (res) {
                setSnackbar({
                    message: "Status updated successfully",
                    severity: "success",
                    open: true,
                });
                refetch();
            }
        } catch (error) {
            setSnackbar({
                message: error?.data?.message || "Something went wrong",
                severity: "error",
                open: true,
            });
        }
    };

    const Action = (row) => {
        const { userId } = row;
        return (
            <div className="actBtnGrps" style={{ display: 'flex', gap: '10px' }}>
                <Button
                    variant="contained"
                    color="primary" // Different color for distinction
                    size="small"
                    onClick={() => openConfirmation(userId, 'APPROVED', true)}
                    disabled={isUpdating}
                >
                    Instant Approve
                </Button>
                <Button
                    variant="contained"
                    color="success"
                    size="small"
                    onClick={() => openConfirmation(userId, 'APPROVED', false)}
                    disabled={isUpdating}
                >
                    Approve
                </Button>
                <Button
                    variant="contained"
                    color="error"
                    size="small"
                    onClick={() => openConfirmation(userId, 'REJECTED')}
                    disabled={isUpdating}
                >
                    Reject
                </Button>
            </div>
        );
    };

    const cols = [
        "name",
        "email",
        "requestedAt",
        "status",
        "actions"
    ];

    const tableData = [];
    if (data?.result?.list?.length) {
        for (const key of data.result.list) {
            tableData.push({
                name: key.name,
                email: key.email,
                requestedAt: key.delink_instagram_updated_at ? format(new Date(key.delink_instagram_updated_at), 'dd MMM yyyy, hh:mm a') : 'N/A',
                status: key.delink_instagram_status,
                userId: key.userId,
                actions: <Action userId={key.userId} />, // Just passing userId to Action component via row prop logic in CustomTable usually passes row
            });
        }
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage - 1);
    };

    const handleChangeRowsPerPage = (event) => {
        setLimit(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleSearch = (e) => {
        setSearch(e.target.value);
        setPage(0);
    }

    const handleClearSearch = () => {
        setSearch("");
        setPage(0);
    }

    return (
        <>
            <CustomizedSnackbars msgData={snackbar} setMsgData={setSnackbar} style={{ maxWidth: '100%' }} />
            <Stack direction={"column"} gap={2}>
                <Stack
                    className="mainTitle  flex-wrap"
                    direction={"row"}
                    alignItems={"center"}
                    justifyContent={"space-between"}
                    sx={{
                        minHeight: '42px',
                        padding: '0px 16px',
                    }}
                >
                    <Typography className="page-title" variant="h1">
                        Delink Instagram Requests
                    </Typography>
                    <Stack direction={"row"} gap={2}>
                        <CustomSearchInput
                            className="inputSearch sContrl p-0"
                            value={search}
                            placeholder={"Search here..."}
                            handleSearch={handleSearch}
                            clearSearch={handleClearSearch}
                            startAdornment={
                                <InputAdornment style={{ borderRadius: '50px !important' }} className="overIcon" position="start"
                                    sx={{
                                        maxHeight: 'none',
                                        height: '38px',
                                        minWidth: '38px',
                                        marginRight: '0px', background: 'none !important', borderRadius: '50px !important'
                                    }}
                                >
                                    <img src={searchIcon} height={20} width={20} alt="" srcset="" />
                                </InputAdornment>
                            }
                        />
                    </Stack>
                </Stack>
                <Box sx={{ padding: '0px 16px' }}>

                    <Box
                        sx={{
                            backgroundColor: '#fff',
                            transition: 'all .5s ease-in-out',
                            position: 'relative',
                            border: '1px solid rgba(170, 170, 170, 0.3)',
                            borderRadius: '12px',
                            boxShadow: '0px 5px 5px 0px rgba(82, 63, 105, 0.05)',
                            overflow: 'hidden',
                        }}>
                        <CustomTable
                            cols={cols}
                            data={tableData}
                            isCheckbox={false}
                            // actionComp={Action} // We are rendering actions directly in data for now to be safe, or if CustomTable supports it we can use actionComp
                            count={data?.result?.total || 0}
                            onPageChange={({ page, rows }) => {
                                setPage(page);
                                setLimit(rows);
                            }}
                        />
                    </Box>
                </Box>
            </Stack>

            {/* Confirmation Dialog */}
            {confirmationState.open && (
                <Dialog
                    open={confirmationState.open}
                    onClose={closeConfirmation}
                >
                    <DialogTitle>
                        {confirmationState.status === 'APPROVED' ? (confirmationState.instant ? 'Instant Approve Request' : 'Approve Request') : 'Reject Request'}
                    </DialogTitle>
                    <DialogContent>
                        <Typography>
                            Are you sure you want to {confirmationState.status === 'APPROVED' ? (confirmationState.instant ? 'instantly approve' : 'approve') : 'reject'} this delink request?
                        </Typography>
                    </DialogContent>
                    <DialogActions sx={{ padding: 2 }}>
                        <Button onClick={closeConfirmation} variant="outlined">Cancel</Button>
                        <Button
                            onClick={handleConfirmAction}
                            variant="contained"
                            color={confirmationState.status === 'APPROVED' ? 'success' : 'error'}
                            autoFocus
                        >
                            {confirmationState.status === 'APPROVED' ? (confirmationState.instant ? 'Instant Approve' : 'Approve') : 'Reject'}
                        </Button>
                    </DialogActions>
                </Dialog>
            )}
        </>
    );
};
export default DelinkRequests;
